<template>
  <section class="checkout-section">
    <div class="checkout-section__header checkout-section__header--no-line">
      <h2 class="checkout-section__title">{{ data.travellers.title }}</h2>
      <div
        class="checkout-section__description"
        v-html="data.travellers.descriptionHtml"
      ></div>
    </div>

    <div class="rooms details-container"
        :class="{ 'details-containerTs': data.brandNameFormatted === Brand.Travelsphere }">
      <h3 class="rooms__title details-container__header" 
          :class="{ 'details-container__headerTs': data.brandNameFormatted === Brand.Travelsphere }">Select Room Types</h3>

      <div class="rooms__body details-container__body">
        <div
          class="rooms__intro details-container__body-intro"
          v-html="data.travellers.introductionHtml"
        ></div>

        <Room
          v-for="(room, index) in rooms"
          :key="room.key"
          :room="room"
          :index="index"
          :data="data"
        />

        <div class="rooms__add-room">
          <a
            href="javascript:void(0)"
            role="button" 
            aria-label="Add another room" 
            title="Add another room"
            v-if="!exceedPassengerLimit"
            :disabled="!canAddRoom"
            @click="addRoom"
            >Add another room</a
          >
        </div>

        <div v-if="hasDuplicateName" class="error-message rooms__name-error">
          <div class="error-message__icon"></div>
          <div class="error-message__text">
            <p>You cannot add two passengers with the same name</p>
          </div>
        </div>

        <p v-if="exceedPassengerLimit" class="rooms__max-passengers">
          Maximum {{ maxPassengers }} travellers
        </p>
      </div>
    </div>

    <template v-if="this.donationData.imageUrl != undefined">
      <div class="rooms details-container" 
           :class="{ 'details-containerTs': this.data.brandNameFormatted === Brand.Travelsphere }">
        <div class="checkout-step-wrapper" 
             :class="{ 'checkout-step-wrapperTs': this.data.brandNameFormatted === Brand.Travelsphere }">

            <picture>
              <img :class="{ 'checkout-step-image': this.data.brandNameFormatted !== Brand.Travelsphere }" 
                 :src="`${this.data.donations.image}?format=webp`"  
                 :alt="this.donationData.name" 
                 loading="lazy"/>
            </picture>  

            <div :class="{ 'container-fluid': this.data.brandNameFormatted !== Brand.Travelsphere }">
              <div :class="{ 'pb-20': this.data.brandNameFormatted !== Brand.Travelsphere }">

                <div v-html="this.data.donations.title"></div>
              
                <div class="personalise__read" 
                     :class="{ 'personalise__read--less': showFullText }" 
                     @click="toggleDescription" 
                     role="button"
                     tabindex="0"
                     :aria-expanded="showFullText"
                     :aria-label="showFullText ? 'Read less' : 'Read more'">
                  {{ showFullText ? "Read less" : "Read more"}}
                </div>
  
                <div v-if="showFullText" 
                     v-html="this.data.donations.descriptionHtml">
                </div>

              </div>
            </div>

        </div>
      </div>
    </template>

    <PriceBreakdown />

    <div class="checkout-section__footer">
      <NavButton
        :back="true"
        :class="{ 'btn btn--outline-gray-color btn--outline-gray-color_sm js-modal resultCardMapTs': this.data.brandNameFormatted === Brand.Travelsphere }"
        text="Back"
        :stepBackAmount="addonSelected ? 1 : 2"
        :isFirstPage="!hasAddons"
      />
      <NavButton
        :disabled="!canContinue"
        @beforeNextStep="setRooms"
        :stepAmount="excursionsVisited && !excursionsExist ? 2 : 1"
      />
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Room from "./../Components/Room.vue";
import NavButton from "./../Components/NavButton.vue";
import PriceBreakdown from "./../Components/PriceBreakdown.vue"
import {Brand} from './../../../../brand.js';

export default {
  name: "Travellers",

  components: {
    Room,
    PriceBreakdown,
    NavButton,
  },

  data: function() {
    return {
      Brand,
      showFullText: false
    };
  },

  computed: {
    ...mapState("checkout", [
      "rooms",
      "availableRooms",
      "maxPassengers",
      "data",
      "excursionData",
      "excursionsExist",
      "excursionsVisited",
      "donationsData",
      "donatingTravellers"
    ]),
    ...mapGetters("checkout", [
      "canAddRoom",
      "addonSelected",
      "hasAddons",
      "roomPassengers",
      "donationData"
    ]),

    canContinue() {
      // check all passengers are valid
      return (
        this.rooms.length &&
        this.rooms.every((room) => {
          return (
            room.passengers.length &&
            room.passengers.every((passenger) =>
              this.$store.getters.formIsValid(passenger)
            )
          );
        }) &&
        !this.hasDuplicateName
      );
    },

    hasDuplicateName() {
      return this.$store.getters["checkout/passengerHasDuplicateName"](
        this.roomPassengers
      );
    },

    exceedPassengerLimit() {
      if (this.roomPassengers.length < this.maxPassengers) {
        return false;
      }
      return true;
    },
  },

  created() {
    this.$store.dispatch("checkout/getDonations"); 
    this.$store.commit("checkout/setToursData");
    GTM.beginCheckout(this.$store.state.checkout);
   },

  activated() {
    this.$store.dispatch("checkout/getAvailableRooms").then(() => {
      if (!this.rooms.length) {
        this.addRoom();
      }
    });
  },

  methods: {
    addRoom() {
      this.$store.commit("checkout/addRoom");
    },

    setRooms() {
      this.$store.dispatch("checkout/rooms");
      this.$store.commit("checkout/setRoomsData", this.data);
      GTM.addPackage(this.$store.state.checkout);
    },

    toggleDescription() {
      this.showFullText = !this.showFullText;
    }
  },
};
</script>
